module.exports = __webpack_public_path__ + "media/assets/avia/sidebar/wizair-da9e7cfe0be2b097f762d22971377b59.png";